
import React, { useState } from 'react';
import { usePerformanceMonitoring } from './performance/usePerformanceMonitoring';
import OverviewTab from './performance/OverviewTab';
import ResourcesTab from './performance/ResourcesTab';
import NetworkTab from './performance/NetworkTab';
import ErrorsDisplay from './performance/ErrorsDisplay';
import TabNavigation from './performance/TabNavigation';

interface PerformanceDisplayProps {
  isVisible?: boolean;
}

const PerformanceDisplay: React.FC<PerformanceDisplayProps> = ({ isVisible = false }) => {
  const { metrics, refreshMetrics } = usePerformanceMonitoring(isVisible);
  const [isExpanded, setIsExpanded] = useState(false);
  const [activeTab, setActiveTab] = useState<'overview' | 'resources' | 'network'>('overview');
  
  if (!isVisible) {
    return null;
  }

  const tabs = [
    { id: 'overview', label: 'Overview' },
    { id: 'resources', label: 'Resources' },
    { id: 'network', label: 'Network' }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'resources':
        return <ResourcesTab metrics={metrics} />;
      case 'network':
        return <NetworkTab metrics={metrics} />;
      case 'overview':
      default:
        return <OverviewTab metrics={metrics} />;
    }
  };

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-md bg-white dark:bg-gray-800 shadow-lg rounded-lg p-4 text-xs">
      <div className="flex justify-between items-center mb-3">
        <h3 className="font-bold text-sm">Performance Metrics</h3>
        <div className="flex gap-2">
          <button
            className="text-xs px-2 py-1 rounded bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600"
            onClick={refreshMetrics}
          >
            Refresh
          </button>
          <button
            className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? 'Collapse' : 'Expand'}
          </button>
        </div>
      </div>
      
      <OverviewTab metrics={metrics} />
      
      {isExpanded && (
        <div className="mt-4">
          <TabNavigation 
            activeTab={activeTab} 
            setActiveTab={setActiveTab} 
            tabs={tabs} 
          />
          
          {renderTabContent()}
          
          <ErrorsDisplay errors={metrics.errors || []} />
        </div>
      )}
    </div>
  );
};

export default PerformanceDisplay;
